import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {isEmpty} from 'lodash/lang';
import {Edit as EditIcon} from '@material-ui/icons';
import {withKluwellTableWrapper, KluwellTableCore, SortingManager} from 'components/common';

const buildClassroomSubscriptionRecords = (classrooms) => {
  const sortedIds = classrooms.sortedIds || [];
  return isEmpty(sortedIds)
    ? []
    : sortedIds.map((classroomId) => {
        const classroom = classrooms[classroomId];
        return {
          record: classroom,
          id: classroomId,
          name: classroom.name,
          pendingSubscriptions: classroom.pendingSubscriptions,
          activatedSubscriptions: classroom.activatedSubscriptions,
          availableSubscriptions: classroom.availableSubscriptions,
          actions: '',
        };
      });
};

const buildClassroomSubscriptionSettings = () => ({
  name: {
    fieldText: 'Classroom',
    formatData: (cell, row) => <Link to={`/classrooms/${row.id}`}>{cell}</Link>,
  },
  pendingSubscriptions: {
    fieldText: 'Pending',
  },
  activatedSubscriptions: {
    fieldText: 'Activated',
  },
  availableSubscriptions: {
    fieldText: 'Available',
  },
  actions: {
    fieldText: 'Actions',
    formatData: (cell, row, restProps) => (
      <span className="table-actions">
        <EditIcon className="cursor-pointer" onClick={() => restProps.showUpdateModal(row.record)} />
      </span>
    ),
  },
});

class SchoolAssignedSubscriptionTableCore extends React.Component {
  static propTypes = {
    recordPages: PropTypes.object.isRequired,
    onSortableFieldClick: PropTypes.func.isRequired,
    showUpdateModal: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.sortingManager = new SortingManager();
  }

  render() {
    const {recordPages, onSortableFieldClick, hiddenFields, showUpdateModal} = this.props;
    const subscriptions = recordPages[recordPages.currentPage] || {};
    const records = buildClassroomSubscriptionRecords(subscriptions);
    const settings = buildClassroomSubscriptionSettings();
    return (
      <KluwellTableCore
        {...{
          key: 'KluwellTableCore',
          records,
          settings,
          sortingManager: this.sortingManager,
          onSortableFieldClick,
          hiddenFields,
          showUpdateModal,
        }}
      />
    );
  }
}

export default withKluwellTableWrapper(SchoolAssignedSubscriptionTableCore);
